module.exports = __webpack_public_path__ + "img/11-3.dd04e7f2.svg";